// Categorías de movimiento de caja: en qué se gastó (o de dónde entró) el
// dinero del cajón.
//
// La lista NO está fija: vive en configuracion_ticket bajo la clave
// 'movimientos_categorias' y se edita en Configuración › Movimientos de caja. Esto de
// aquí es la semilla y el respaldo si la clave falta o llega corrupta — mismo
// mecanismo que las categorías de objetivos en catalogos.ts.
//
// Espejo de backend/src/utils/categoriasMovimiento.js: los `value` son los que
// se guardan en movimientos_caja.categoria.
export type CategoriaMovimiento = {
  value: string;
  label: string;
  emoji: string;
  aplica: 'retiro' | 'deposito' | 'ambos';
  sistema: boolean;
};

// 'propina' y 'otro' están marcadas sistema:true y la UI no deja borrarlas:
// de 'propina' depende que el pago a meseros se clasifique solo, y 'otro' es el
// DEFAULT de la columna y el destino de todo movimiento sin clasificar.
export const CATEGORIAS_MOVIMIENTO_DEFAULT: CategoriaMovimiento[] = [
  { value: 'propina',   label: 'Propina a mesero', emoji: '🙋', aplica: 'retiro',   sistema: true  },
  { value: 'proveedor', label: 'Pago a proveedor', emoji: '🚚', aplica: 'retiro',   sistema: false },
  { value: 'gasto',     label: 'Gasto o compra',   emoji: '🧾', aplica: 'retiro',   sistema: false },
  { value: 'banco',     label: 'Llevar al banco',  emoji: '🏦', aplica: 'retiro',   sistema: false },
  { value: 'fondo',     label: 'Fondo o cambio',   emoji: '💵', aplica: 'deposito', sistema: false },
  { value: 'otro',      label: 'Otro',             emoji: '📌', aplica: 'ambos',    sistema: true  },
];

export function parseCategoriasMovimiento(json?: string): CategoriaMovimiento[] {
  if (!json) return CATEGORIAS_MOVIMIENTO_DEFAULT;
  try {
    const arr = JSON.parse(json);
    return Array.isArray(arr) && arr.length > 0 ? arr : CATEGORIAS_MOVIMIENTO_DEFAULT;
  } catch { return CATEGORIAS_MOVIMIENTO_DEFAULT; }
}

// Las categorías que tienen sentido para un retiro no son las mismas que para
// un depósito: mostrar todas confundiría al cajero.
export const categoriasDe = (cats: CategoriaMovimiento[], tipo: 'retiro' | 'deposito') =>
  cats.filter(c => c.aplica === tipo || c.aplica === 'ambos');

// Categoría preseleccionada al abrir el formulario: la primera del tipo, sin
// dar por hecho que existe alguna en particular (el admin pudo borrarlas).
export const categoriaDefault = (cats: CategoriaMovimiento[], tipo: 'retiro' | 'deposito') =>
  categoriasDe(cats, tipo)[0]?.value || 'otro';

// Sirve también para movimientos viejos cuya categoría ya no está en el
// catálogo: se muestran como "Otro" en vez de dejar el hueco en blanco.
export const labelCategoria = (cats: CategoriaMovimiento[], v?: string) =>
  cats.find(c => c.value === v)?.label || 'Otro';

export const emojiCategoria = (cats: CategoriaMovimiento[], v?: string) =>
  cats.find(c => c.value === v)?.emoji || '📌';

// Un nombre escrito por el usuario ("Renta del local") se vuelve la clave que
// se guarda en la base ("renta_del_local").
export const claveDesdeNombre = (nombre: string) =>
  nombre.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
